window.popStateDetected = false
window.onpopstate = function (event) {
  window.popStateDetected = true
}

export default async (to, from, next) => {
  window.popStateDetected = false
  next()
}
